/**
 * Readable names for environment damage sources (DJ 2026-10-23). Zones damage and kill under a
 * `zone:<type>:<zoneId>` tag (src/server/systems/ZoneSystem.ts); the combat log showed that raw tag
 * ("[zone:spikes:hush_course_floor_spikes_1] killed [you]") or "???" for the hit. A zone type reads
 * as itself, title-cased ("Spikes"); anything that is not a zone tag is left to the caller.
 */
const ZONE_TAG = /^zone:([a-z][a-z0-9_]*):/;

export function environmentSourceName(id: string | null | undefined): string | null {
  const match = id ? ZONE_TAG.exec(id) : null;
  if (!match) return null;
  return match[1].split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}
